import { render, staticRenderFns } from "./NewPortfolioManageCard.vue?vue&type=template&id=72da63ca"
import script from "./NewPortfolioManageCard.vue?vue&type=script&lang=js"
export * from "./NewPortfolioManageCard.vue?vue&type=script&lang=js"
import style0 from "./NewPortfolioManageCard.vue?vue&type=style&index=0&id=72da63ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports